import axios from "axios";

/**
 * Opens a printable Enrollment Slip in a new window.
 * School name is shown in the header; school contact info (email/phone/address) in the footer.
 * Returns false if the pop-up was blocked, true otherwise.
 */
export const printEnrollmentSlip = async ({
  studentName,
  photo, // relative /uploads path or null
  enrollmentNo,
  sessionName,
  gradeName,
  subjects,
  status,
  enrolledAt, // preformatted string
}) => {
  let school = {};
  try {
    const res = await axios.get("/api/schools/my-settings");
    school = res.data?.data || {};
  } catch (e) {
    /* print without school info */
  }
  const schoolName = school.schoolName || "";
  const contactParts = [
    school.email || school.adminEmail,
    school.phone,
    school.address && school.country ? `${school.address}, ${school.country}` : school.address || school.country,
  ].filter(Boolean);

  const html = `<!DOCTYPE html>
<html>
<head>
  <title>Enrollment Slip - ${studentName || ""}</title>
  <style>
    body { font-family: 'Segoe UI', Arial, sans-serif; color: #222; margin: 40px; display: flex; flex-direction: column; min-height: calc(100vh - 80px); }
    .header { text-align: center; border-bottom: 2px solid #333; padding-bottom: 12px; margin-bottom: 24px; }
    .header h1 { margin: 0 0 4px; font-size: 22px; }
    .header h2 { margin: 0; font-size: 16px; font-weight: normal; color: #555; }
    .photo-row { display: flex; justify-content: flex-end; margin-bottom: -8px; }
    .photo, .photo-placeholder { width: 110px; height: 130px; border: 1px solid #999; object-fit: cover; }
    .photo-placeholder { display: flex; align-items: center; justify-content: center; color: #999; font-size: 12px; background: #fafafa; }
    table { width: 100%; border-collapse: collapse; margin-top: 8px; }
    td { padding: 8px 10px; border: 1px solid #bbb; font-size: 14px; }
    td.label { width: 32%; background: #f4f4f4; font-weight: 600; }
    .status { text-transform: capitalize; }
    .signatures { margin-top: 60px; display: flex; justify-content: space-between; font-size: 13px; }
    .sig { border-top: 1px solid #333; padding-top: 4px; width: 200px; text-align: center; }
    .school-footer { margin-top: auto; padding-top: 40px; }
    .school-footer .line { border-top: 1px solid #999; padding-top: 8px; text-align: center; font-size: 12px; color: #555; }
    .school-footer .line span + span::before { content: "  |  "; white-space: pre; }
    @media print { body { margin: 16px; min-height: calc(100vh - 32px); } }
  </style>
</head>
<body>
  <div class="header">
    ${schoolName ? `<h1>${schoolName}</h1>` : ""}
    <h2>Student Enrollment Slip</h2>
  </div>
  <div class="photo-row">
    ${photo
      ? `<img class="photo" src="${window.location.origin}${photo}" alt="Student Photo" />`
      : `<div class="photo-placeholder">Affix Photo Here</div>`}
  </div>
  <table>
    <tr><td class="label">Student Name</td><td>${studentName || "-"}</td></tr>
    <tr><td class="label">Enrollment #</td><td>${enrollmentNo || "-"}</td></tr>
    <tr><td class="label">Session</td><td>${sessionName || "-"}</td></tr>
    <tr><td class="label">Grade / Class</td><td>${gradeName || "-"}</td></tr>
    <tr><td class="label">Subjects</td><td>${subjects || "-"}</td></tr>
    <tr><td class="label">Status</td><td class="status">${status || "-"}</td></tr>
    <tr><td class="label">Enrollment Date</td><td>${enrolledAt || "-"}</td></tr>
    <tr><td class="label">Printed On</td><td>${new Date().toLocaleDateString()}</td></tr>
  </table>
  <div class="signatures">
    <div class="sig">Parent / Guardian Signature</div>
    <div class="sig">School Administration</div>
  </div>
  ${contactParts.length
    ? `<div class="school-footer"><div class="line">${contactParts.map((p) => `<span>${p}</span>`).join("")}</div></div>`
    : ""}
  <script>window.onload = function () { window.print(); };</script>
</body>
</html>`;

  const win = window.open("", "_blank", "width=800,height=900");
  if (!win) return false;
  win.document.write(html);
  win.document.close();
  return true;
};
